import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Table, Button, Alert } from 'react-bootstrap';
import { categoriesApi } from '../services/api';
import { Category } from '../types';

const CategoryList: React.FC = () => {
  const navigate = useNavigate();
  const [categories, setCategories] = useState<Category[]>([]);
  const [loading, setLoading] = useState(true);
  const [success, setSuccess] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    const token = localStorage.getItem('admin_token');
    if (!token) {
      navigate('/admin/login');
      return;
    }

    fetchCategories();
  }, [navigate]);

  const fetchCategories = async () => {
    try {
      const data = await categoriesApi.getAll();
      setCategories(data);
    } catch (error: any) {
      console.error('Error loading categories:', error);
      setError('Erro ao carregar categorias');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2><i className="bi bi-tags me-2"></i>Gerenciar Categorias</h2>
        <Button variant="primary" onClick={() => navigate('/admin/categorias/criar')}>
          <i className="bi bi-plus-lg me-2"></i>
          Nova Categoria
        </Button>
      </div>

      {success && (
        <Alert variant="success" dismissible onClose={() => setSuccess('')}>
          {success}
        </Alert>
      )}

      {error && (
        <Alert variant="danger" dismissible onClose={() => setError('')}>
          {error}
        </Alert>
      )}

      {loading ? (
        <div className="text-center py-5">
          <div className="loading-spinner"></div>
        </div>
      ) : (
        <div style={{ background: 'white', borderRadius: '12px', overflow: 'hidden' }}>
          <Table responsive hover>
            <thead style={{ background: 'var(--color-primary)', color: 'white' }}>
              <tr>
                <th style={{ width: '60px' }}>ID</th>
                <th>Nome</th>
                <th style={{ width: '120px' }}>Status</th>
                <th style={{ width: '180px' }}>Ações</th>
              </tr>
            </thead>
            <tbody>
              {categories.length === 0 ? (
                <tr>
                  <td colSpan={4} className="text-center py-5 text-muted">
                    Nenhuma categoria cadastrada. Clique em "Nova Categoria" para começar.
                  </td>
                </tr>
              ) : (
                categories.map((category) => (
                  <tr key={category.id}>
                    <td>{category.id}</td>
                    <td>
                      <strong>{category.nome}</strong>
                    </td>
                    <td>
                      <span className={`badge ${category.ativo ? 'bg-success' : 'bg-secondary'}`}>
                        {category.ativo ? 'Ativa' : 'Inativa'}
                      </span>
                    </td>
                    <td>
                      <Button
                        variant="outline-primary"
                        size="sm"
                        className="me-2"
                        onClick={() => navigate(`/admin/categorias/editar/${category.id}`)}
                        title="Editar"
                      >
                        <i className="bi bi-pencil"></i>
                      </Button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </Table>
        </div>
      )}
    </div>
  );
};

export default CategoryList;
